import react from 'react'
import { PEN_REMAININGYESTERDAY } from '../..';

import { getSectionById } from '../../../Assets/TestData/sectionsData'

interface Section_Props {
  sectionId: number
  onPenClick?: (penId: number) => void
}
/**
 * SECTION_REMAININGYESTERDAY
 * @param sectionId Unique identifier for each section.
 * @param onPenClick OnClick event to handle penId.
 * @returns a section of pens for Freeda Location Feeder systems.
 */
export default function SECTION_REMAININGYESTERDAY({ sectionId }: Section_Props) {
  const section = getSectionById(sectionId);

  // Error throwback if no section number excists
  if (!section) {
    return <div>Section {sectionId} not found</div>;
  }

  const renderContent = () => {
    return section.pens.map(pen => (
      <PEN_REMAININGYESTERDAY
        key={pen.animal?.animalId}
        penId={pen.penId}
      />
    ));
  }

  return (
      <div style={{ width: "fit-content", height: "fit-content" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", width: "fit-content", gap: "10px", borderRadius: "10px", overflow: "hidden" }}>
          {renderContent()}
        </div>
      </div>
  );
}